enum FontFamily {
    interState = 'Interstate',
    inter = 'Inter',
    helveticaNeue = 'Helvetica Neue',
    helvetica = 'Helvetica',
    arial = 'Arial',
    sansSerif = 'sans-serif',
}

export default FontFamily;
